import get from 'lodash/get';
import { createSelector } from 'reselect';

export const getPagination = (state) => get(state, 'depreciations.list.pagination', {});
export const getFilters = (state) => get(state, 'depreciations.list.filters', {});

export const getDepreciationsIds = (state) =>
  get(state, 'depreciations.list.result.depreciations', []);
export const getDepreciations = (state) =>
  get(state, 'depreciations.list.entities.depreciations', {});

export const getIsLoading = (state) => get(state, 'depreciations.list.isLoading', false);
export const getNeedFetch = (state) => get(state, 'depreciations.list.needFetch', false);

export const getIsFetching = (state) => get(state, 'depreciations.form.isFetching', false);
export const getIsFetchingConfig = (state) =>
  get(state, 'depreciations.form.isFetchingConfig', false);
export const getIsSaving = (state) => get(state, 'depreciations.form.isSaving', false);
export const getEditing = (state) => get(state, 'depreciations.form.editing', false);

export const getVisibleDepreciations = createSelector(
  [getDepreciationsIds, getDepreciations],
  (ids, depreciations) =>
    ids.map((id) => depreciations[id]).filter((depreciation) => !depreciation.deleted)
);



// WEBPACK FOOTER //
// src/modules/secured/modules/depreciations/selectors/depreciations_selectors.js